import { getSqliteType, isNumericType } from ".";

export function sqliteEquals(a: unknown, b: unknown): boolean {
	// SQLite type hierarchy: NULL < INTEGER < REAL < TEXT < BLOB

	// NULL comparisons always return NULL (which is falsy in boolean context)
	if (a === null || a === undefined || b === null || b === undefined) {
		return false;
	}

	// Convert to SQLite types
	const aType = getSqliteType(a);
	const bType = getSqliteType(b);

	// SQLite only compares values of the same type
	if (aType !== bType) {
		return false;
	}

	// Now we know they're the same type
	if (isNumericType(aType)) {
		return Number(a) === Number(b);
	}

	// Text comparison
	return String(a) === String(b);
}
